import React from 'react';
import RecetasPacienteUI from './RecetasPacienteUI';

const RecetasPaciente = ({ visible, onClose, id_paciente, id_cita }) => {
  return <RecetasPacienteUI visible={visible} onClose={onClose} id_paciente={id_paciente} id_cita={id_cita} />;
};

export default RecetasPaciente;